import { ReportColumn } from "@/types/evaluate";
import React from "react";
import { HeaderIcon } from "./HeaderIcon";

interface HeaderContentProps {
  column: ReportColumn;
}

export const HeaderContent: React.FC<HeaderContentProps> = ({ column }) => (
  <div
    className={`pointer-events-none flex h-full w-full cursor-text items-center justify-center gap-x-1 text-center font-semibold ${
      !!column.errors ? "text-red-500" : "text-gray-700"
    }`}
  >
    <HeaderIcon columnType={column.column_type} hasError={!!column.errors} />
    {column.name}
  </div>
);
